'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _clickOutside = require('click-outside');

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _objectAssign2 = require('object-assign');

var _objectAssign3 = _interopRequireDefault(_objectAssign2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var clickOutsideInstance = function clickOutsideInstance() {};

var propTypes = {
	align: {
		type: 'string'
	},
	children: {
		type: 'array'
	},
	class: {
		type: 'string'
	},
	styles: {
		type: 'object'
	}
};

var defaultProps = {
	align: 'left',
	bottom: 0,
	styles: {},
	top: 0
};

var afterRender = function afterRender(_ref, el) {
	var props = _ref.props;
	var onClickOutside = props.onClickOutside;


	clickOutsideInstance();

	if (onClickOutside) {
		clickOutsideInstance = (0, _clickOutside2.default)(el, onClickOutside);
	}
};

var render = function render(_ref2) {
	var _objectAssign;

	var props = _ref2.props;
	var align = props.align,
	    bottom = props.bottom,
	    children = props.children,
	    legacyStyles = props.legacyStyles,
	    open = props.open,
	    styles = props.styles,
	    styleClasses = props.styleClasses,
	    top = props.top;


	var essentialStyles = (0, _objectAssign3.default)({}, styles, (_objectAssign = {
		'z-index': 10000,
		'overflow-y': 'auto',
		position: 'fixed',
		top: top
	}, _defineProperty(_objectAssign, align, 0), _defineProperty(_objectAssign, 'bottom', bottom), _defineProperty(_objectAssign, 'transform', 'translateX(' + (open ? '0%' : align === 'left' ? '-100%' : '100%') + ')'), _defineProperty(_objectAssign, '-webkit-transform', 'translateX(' + (open ? '0%' : align === 'left' ? '-100%' : '100%') + ')'), _objectAssign));

	var style = styleClasses && styleClasses.Slideout ? essentialStyles : (0, _objectAssign3.default)({}, essentialStyles, legacyStyles);

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Slideout', props.class, styleClasses && styleClasses.Slideout], 'data-style-attr': 'Slideout', style: style },
		children
	);
};

exports.default = { afterRender: afterRender, defaultProps: defaultProps, propTypes: propTypes, render: render };
